import React, { useState } from "react";
import { Mail, Phone, MapPin } from "lucide-react";

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate form
    if (
      !formData.name ||
      !formData.email ||
      !formData.subject ||
      !formData.message
    ) {
      alert("Please fill in all fields!");
      return;
    }

    // Your WhatsApp number (replace with your actual number)
    // Format: country code + number (no + or spaces or dashes)
    // Example: For India +91 98765 43210, use: 919876543210
    const phoneNumber = "+918472916169"; // REPLACE THIS WITH YOUR NUMBER

    // Create structured message
    const message = `*New Contact Form Submission*

📝 *Name:* ${formData.name}
📧 *Email:* ${formData.email}
📌 *Subject:* ${formData.subject}

💬 *Message:*
${formData.message}

---
Sent from Contact Form`;

    // Create WhatsApp URL
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;

    // Open WhatsApp in new tab
    window.open(whatsappURL, "_blank");

    // Reset form
    setFormData({ name: "", email: "", subject: "", message: "" });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 py-16 px-6 mt-12">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-block px-6 py-2 border border-blue-400 text-blue-400 rounded-full text-sm mb-6">
            GET IN TOUCH
          </div>
          <h1 className="text-5xl font-bold text-white mb-6">
            Start Your Digital Journey
          </h1>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto">
            Ready to transform your business? Let's discuss how we can help
            bring your vision to life with innovative technology solutions.
          </p>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Form Section */}
          <div className="space-y-6">
            <div className="grid grid-cols-2 gap-6">
              <div>
                <label className="block text-gray-300 text-sm mb-2">
                  Full Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your Name"
                  className="w-full bg-slate-700/50 text-white px-4 py-3 rounded-lg border border-slate-600 focus:border-blue-500 focus:outline-none placeholder-gray-500"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-300 text-sm mb-2">
                  Email Address
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="your@email.com"
                  className="w-full bg-slate-700/50 text-white px-4 py-3 rounded-lg border border-slate-600 focus:border-blue-500 focus:outline-none placeholder-gray-500"
                  required
                />
              </div>
            </div>

            <div>
              <label className="block text-gray-300 text-sm mb-2">
                Subject
              </label>
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="Project Inquiry"
                className="w-full bg-slate-700/50 text-white px-4 py-3 rounded-lg border border-slate-600 focus:border-blue-500 focus:outline-none placeholder-gray-500"
                required
              />
            </div>

            <div>
              <label className="block text-gray-300 text-sm mb-2">
                Message
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Tell us about your project and how we can help.."
                rows="6"
                className="w-full bg-slate-700/50 text-white px-4 py-3 rounded-lg border border-slate-600 focus:border-blue-500 focus:outline-none placeholder-gray-500 resize-none"
                required
              ></textarea>
            </div>

            <button
              onClick={handleSubmit}
              className="w-full bg-blue-500 text-white px-8 py-4 rounded-lg hover:bg-blue-600 transition font-medium text-lg"
            >
              Send via WhatsApp
            </button>
          </div>

          {/* Contact Information */}
          <div className="lg:pl-12">
            <h2 className="text-3xl font-bold text-white mb-8">
              Contact Information
            </h2>

            <div className="space-y-8">
              <div className="flex items-start gap-4">
                <div className="bg-blue-500/20 p-3 rounded-lg">
                  <Mail className="w-6 h-6 text-blue-400" />
                </div>
                <div>
                  <div className="text-gray-400 text-sm mb-1">Email</div>
                  <div className="text-white text-lg">hello@postmint.com</div>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-blue-500/20 p-3 rounded-lg">
                  <Phone className="w-6 h-6 text-blue-400" />
                </div>
                <div>
                  <div className="text-gray-400 text-sm mb-1">Phone</div>
                  <div className="text-white text-lg">+1 (555) 123-4567</div>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-blue-500/20 p-3 rounded-lg">
                  <MapPin className="w-6 h-6 text-blue-400" />
                </div>
                <div>
                  <div className="text-gray-400 text-sm mb-1">Address</div>
                  <div className="text-white text-lg">
                    123 Tech Street, Digital City, DC 12345
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
